/* @flow */
import Collection from 'lib/Collection';
import GroupMembership from 'entities/GroupMembership';
import GroupMemberships from 'collections/GroupMemberships';
import Subscriber from 'entities/Subscriber';
import PotentialChatMember from 'entities/PotentialChatMember';

class RootGroupMemberships extends Collection {
  // $FlowFixMe
  constructor(models, options) {
    super(models, options);
    this.comparator = (a, b) => {
      return a.getSortKey().localeCompare(b.getSortKey());
    };
    this.sort();
  }

  initialize() {
    // FIXME: Replace PCM with GCQ before release
    this.url = '/chats/members/potential/';
    this.model = PotentialChatMember;
  }

  parse(response: Object) {
    return response;
  }

  // Convert from PotentialChatMember objects to GroupMembership objects
  getGroupMemberships() {
    // FIXME: There is no created_at date being returned
    // by the backend from /chats/members/(search/eligible/potential) query,
    // so we have no date to put for each user's subscribed_at or created_at
    // dates. Right now we are just using a placeholder value.
    return new GroupMemberships(
      this.models.map((member) => {
        return new GroupMembership({
          id: member.getUser().id,
          user: new Subscriber({
            id: member.getUser().id,
            name: member.getName(),
            note: member.getNote(),
            role: member.getRole(),
            first_name: member.getFirstName(),
            last_name: member.getLastName(),
            signature: member.getUser().getSignature(),
            office_hours: member.getUser().getOfficeHours(),
            color: member.getUser().getColor(),
            initials: member.getUser().getInitials(),
            blocked: member.getUser().isBlocked(),
          }),
          created_at: new Date(0), // Use UNIX Epoch as placeholder
          group_id: null,
          can_become_owner: false,
          role: member.getRole(),
          can_unsubscribe: false,
          can_chat: member.isEligible(),
        });
      })
    );
  }
}

export default RootGroupMemberships;



// WEBPACK FOOTER //
// ./src/collections/RootGroupMemberships.js